import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';

import TranscriptionBillingResource from 'flow/api/transcriptionbilling';
import { ExtensionKey } from 'flow/types/EntityKeys';

export type TranscriptionDestinationType = 'personal' | 'business';

export type TranscriptionBillingResponseDTO = {
    remainingMinutes: number;
    usedMinutes: number;
    totalMinutes: number;
};

const getRemainingQuota = (
    extensionKey: ExtensionKey,
    destination: TranscriptionDestinationType,
): Promise<TranscriptionBillingResponseDTO> =>
    new Promise((resolve, reject) => {
        TranscriptionBillingResource.getRemainingQuota(
            { onResult: resolve, onError: reject },
            extensionKey,
            destination,
        );
    });

export const useRemainingQuota = (
    extensionKey: ExtensionKey,
    destination: TranscriptionDestinationType,
) =>
    useAuthenticatedQuery({
        queryKey: ['transcriptionQuota', extensionKey, destination],
        queryFn: () => getRemainingQuota(extensionKey, destination),
    });
